import { useContext } from "react";

import { TableColumnSettingsContext } from "./TableColumnSettingsContext";

export const useTableColumnSettingsProvider = () => {
  const tableColumnSettings = useContext(TableColumnSettingsContext);

  if (!tableColumnSettings) {
    throw new Error(
      "useTableColumnSettingsProvider must be used within a TableColumnSettingsProvider",
    );
  }

  return tableColumnSettings;
};
